// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import HealthFacilities__AssessmentFillController from "./health_facilities/assessment_fill_controller"
application.register("health-facilities--assessment-fill", HealthFacilities__AssessmentFillController)

import HealthFacilities__PatientSyncController from "./health_facilities/patient_sync_controller"
application.register("health-facilities--patient-sync", HealthFacilities__PatientSyncController)

import HealthFacilities__MedicalHistoryController from "./health_facilities/medical_history_controller"
application.register("health-facilities--medical-history", HealthFacilities__MedicalHistoryController)

import HealthFacilities__PhysicalExaminationController from "./health_facilities/physical_examination_controller"
application.register("health-facilities--physical-examination", HealthFacilities__PhysicalExaminationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import HealthFacilities__ConsultationSoapController from "./health_facilities/consultation_soap_controller"
application.register("health-facilities--consultation-soap", HealthFacilities__ConsultationSoapController)

import HealthFacilities__SignsSymptomsController from "./health_facilities/signs_symptoms_controller"
application.register("health-facilities--signs-symptoms", HealthFacilities__SignsSymptomsController)

import HealthFacilities__OtherComplaintRequiredController from "./health_facilities/other_complaint_required_controller"
application.register("health-facilities--other-complaint-required", HealthFacilities__OtherComplaintRequiredController)

import HealthFacilities__LabStatusController from "./health_facilities/lab_status_controller"
application.register("health-facilities--lab-status", HealthFacilities__LabStatusController)

import HealthFacilities__IcdSelectController from "./health_facilities/icd_select_controller"
application.register("health-facilities--icd-select", HealthFacilities__IcdSelectController)

import HealthFacilities__PatientSelectController from "./health_facilities/patient_select_controller"
application.register("health-facilities--patient-select", HealthFacilities__PatientSelectController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import HealthFacilities__MedicineFormController from "./health_facilities/medicine_form_controller"
application.register("health-facilities--medicine-form", HealthFacilities__MedicineFormController)


import HealthFacilities__EncounterExportController from "./health_facilities/encounter_export_controller"
application.register("health-facilities--encounter-export", HealthFacilities__EncounterExportController)

import HealthFacilities__DiagnosticRowController from "./health_facilities/diagnostic_row_controller"
application.register("health-facilities--diagnostic-row", HealthFacilities__DiagnosticRowController)

import HealthFacilities__DiagnosticListController from "./health_facilities/diagnostic_list_controller"
application.register("health-facilities--diagnostic-list", HealthFacilities__DiagnosticListController)

import HealthFacilities__CbcController from "./health_facilities/cbc_controller"
application.register("health-facilities--cbc", HealthFacilities__CbcController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HealthFacilities__DeleteConfirmController from "./health_facilities/delete_confirm_controller"
application.register("health-facilities--delete-confirm", HealthFacilities__DeleteConfirmController)

import HealthFacilities__GlucoseConvertController from "./health_facilities/glucose_convert_controller"
application.register("health-facilities--glucose-convert", HealthFacilities__GlucoseConvertController)

import HealthFacilities__NcdSubFieldsController from "./health_facilities/ncd_sub_fields_controller"
application.register("health-facilities--ncd-sub-fields", HealthFacilities__NcdSubFieldsController)

import HealthFacilities__SocialHistoryController from "./health_facilities/social_history_controller"
application.register("health-facilities--social-history", HealthFacilities__SocialHistoryController)

import HealthFacilities__RosController from "./health_facilities/ros_controller"
application.register("health-facilities--ros", HealthFacilities__RosController)

import DialogOpenerController from './dialog_opener_controller'
application.register('dialog-opener', DialogOpenerController)

import ImportSelectController from './import_select_controller'
application.register('import-select', ImportSelectController)

import NumericInputController from './numeric_input_controller'
application.register('numeric-input', NumericInputController)

import HealthFacilities__DiagnosticExamFormController from "./health_facilities/diagnostic_exam_form_controller"
application.register("health-facilities--diagnostic-exam-form", HealthFacilities__DiagnosticExamFormController)

import Admin__DecryptXmlController from "./admin/decrypt_xml_controller"
application.register("admin--decrypt-xml", Admin__DecryptXmlController)
